/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProductStockRequest
 */
export interface UpdateProductStockRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateProductStockRequest
     */
    stock: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductStockRequest
     */
    refillPolicy: UpdateProductStockRequestRefillPolicyEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductStockRequest
     */
    refillValue?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductStockRequest
     */
    lowStockThreshold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductStockRequest
     */
    hideOnLowStock?: boolean;
}


/**
 * @export
 */
export const UpdateProductStockRequestRefillPolicyEnum = {
    UntilSoldOut: 'until-sold-out',
    RefillShift: 'refill-shift',
    RefillDaily: 'refill-daily',
    JustToday: 'just-today'
} as const;
export type UpdateProductStockRequestRefillPolicyEnum = typeof UpdateProductStockRequestRefillPolicyEnum[keyof typeof UpdateProductStockRequestRefillPolicyEnum];


/**
 * Check if a given object implements the UpdateProductStockRequest interface.
 */
export function instanceOfUpdateProductStockRequest(value: object): value is UpdateProductStockRequest {
    if (!('stock' in value) || value['stock'] === undefined) return false;
    if (!('refillPolicy' in value) || value['refillPolicy'] === undefined) return false;
    return true;
}

export function UpdateProductStockRequestFromJSON(json: any): UpdateProductStockRequest {
    return UpdateProductStockRequestFromJSONTyped(json, false);
}

export function UpdateProductStockRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProductStockRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'stock': json['stock'],
        'refillPolicy': json['refillPolicy'],
        'refillValue': json['refillValue'] == null ? undefined : json['refillValue'],
        'lowStockThreshold': json['lowStockThreshold'] == null ? undefined : json['lowStockThreshold'],
        'hideOnLowStock': json['hideOnLowStock'] == null ? undefined : json['hideOnLowStock'],
    };
}

export function UpdateProductStockRequestToJSON(json: any): UpdateProductStockRequest {
    return UpdateProductStockRequestToJSONTyped(json, false);
}

export function UpdateProductStockRequestToJSONTyped(value?: UpdateProductStockRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stock': value['stock'],
        'refillPolicy': value['refillPolicy'],
        'refillValue': value['refillValue'],
        'lowStockThreshold': value['lowStockThreshold'],
        'hideOnLowStock': value['hideOnLowStock'],
    };
}

